import { Component, OnInit } from '@angular/core';
import { NavBarService } from '../../../services/nav-bar.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { MenuNode } from '../../../classes';
import { EnabledNodesPipe } from '../../../pipes/enabled-nodes.pipe';
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
	node : MenuNode = undefined;
  currentElement : MenuNode = undefined;
  menuElements : Array<MenuNode> = undefined;
	smallLetters : string="";
	bigLetters : string="";

	_gated:boolean=false;
  constructor(
  	private navBar:NavBarService,
  	private iconBar:IconBarService,
  	private menuService:MenuService,
  	private ioService:DataIoService,
    private enabledNodes: EnabledNodesPipe
  ) { }
  b():string{
  	//return this.bigLetters;
    if(this._gated){
      return this.bigLetters;
    }
    return this.currentElement.getTitle();
    return '';
  }
  unit():string{
    console.log("Unit for "+this.node.getTitle()+": "+this.currentElement.getUnit());
    if(!this._gated){
      return this.currentElement.getUnit();
    }
    return '';
  }
  s():string{
    if(this.node.getIdentifier() == 'off'){
      return '';
    }
    if(this.hasParameter('hideIndex')){
      return '';
    }
    if(this._gated){
      return this.smallLetters;
    }
  	if(this.menuElements){
      return (this.menuElements.indexOf(this.currentElement)+1)+"'"+this.menuElements.length;
    }
    return '';
  }
  getCurrentIndex():number{
    return this.menuElements.indexOf(this.currentElement);
  }
  next():void{
    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx++;
    if(idx >= length){
      idx = 0;
    }
    this.setCurrentElement(this.menuElements[idx]);
  }
  previous():void{
    let idx = this.getCurrentIndex();
    let length = this.menuElements.length;
    idx--;
    if(idx < 0){
      idx = (length-1);
    }
    this.setCurrentElement(this.menuElements[idx]);

    this.setCurrentElement(this.menuElements[(idx++)%length]);
  }








  handler(evt){
  	switch(evt){
  		case 'menu':{
        if(this.node.getIdentifier() == 'chimneysweepmode'){
          console.log("Trying to go to fachhandwerker-codeabfrage");
          this.menuService.goto('fachhandwerker-codeabfrage');
          console.log("going?!");
        }
  			return;
  		}
  		case 'confirm':{
  			if(this._gated){
  				this.menuService.goto(this.node.getTargetNode());
          if(this.node.getIdentifier() == 'chimneysweepmode'){
            this.iconBar.disable();
            this.navBar.disableAll();
            this.navBar.enable('chimneysweep');
          }
  				return;
  			}
        this.currentElement.selected = "true"
        this.menuService.goto(this.currentElement.getTargetNode());
  			return;
  		}
      case 'up':{
        this.next();
        return;
      }
      case 'down':{
        this.previous();
        return;
      }
	  	case 'back':{
        console.log("going back on "+this.node.getIdentifier());
        let backTarget = this.node.getBackTargetNode();
        if(backTarget){
          this.menuService.goto(backTarget);
        }else{
          console.log("Nevermind... Not going back");
        }
        return;
	  	}
	  	default:{
	  		return;
	  	}
  	}
  }




  hasParameter(p:string):boolean{
  	if(this.node){
  		return this.node.hasParameter(p);
  	}
  	return false;
  }
  subscription:any=undefined;
  ngOnDestroy(){
    this.customDestroy();
  }
  elements = Array<MenuNode>();

  ngOnInit() {
	  this.node = this.menuService.getCurrentNode();
    this.iconBar.saveState('onMenuInit');
  	if(this.hasParameter('gate')){
  		this._gated = true;
  		this.bigLetters = 'OFF';
  	}
  	if(this.node.getIdentifier() != 'chimneysweepmode' && this.node.isDescendantOf('chimneysweepmode')){
  		this.navBar.disableAll();
      this.navBar.enable('chimneysweep');
  	}
    if(this.node.getIdentifier() == 'chimneysweepmode'){
      this.navBar.enableAll();
      this.navBar.blink('chimneysweep');
      //this.iconBar.enable();
    }
    this.getMenuItems();
    this.findSelected();
  	this.subscription = this.ioService.inputs.events$.subscribe( (evt)=>{
  		this.handler(evt);
  	});
    
  }
  findSelected(){
    let selected = null;

    for(let el of this.menuElements){
        if(el.isSelected()){
            selected = el;
            if(el.selected == 'true'){
                el.selected = '';
            }
        }
        for(let subEl of el.getChilds()){
            if(subEl.isSelected()){
                selected = subEl;
                if(subEl.selected == 'true'){
                    subEl.selected = '';
                }
            }
        }
    }
    if(selected != null){
      this.setCurrentElement(selected);
    }
  }
  customDestroy(){
      //this.debug("#### OnDestroy, unsubscribing.");
      if(this.subscription){
        this.subscription.unsubscribe();
      }
      //this.debug("#### OnDestroy, unsubscribed.");
      this.subscription = null;
      this.currentElement.selected ="true";
      this.node.run((node)=>node.removeFilter(this.node.getTitle()),3);
      this.iconBar.restoreState('onMenuInit');
  }

  getMenuItems():void{
    var _this = this;
    this.node.run(function (node) { return node.setFilter(_this.node.getTitle(), _this.enabledNodes.transform); }, 3);
    this.menuElements = this.node.getChilds();
    this.setCurrentElement(this.node.getChildByIndex(0));
  }

  setCurrentElement(node:MenuNode){
    this.currentElement = node;
    if(!this._gated){
      this.iconBar.disableAll();
    }
    this.ioService.infoTextAvailable(this.currentElement);
    let icon = this.currentElement.getIcon();
    if( icon && this.iconBar.knowsOf(icon) ){
      console.log("Icon found. Enabling icon "+icon);
      this.iconBar.enableIcon(icon);
      if(!this._gated){
        this.iconBar.enable();
      }
    }else{
      console.log("Iconbar does not know of icon "+icon);
    }

  }
}
